import React, { useContext, useState, useEffect } from "react";
import { object, func, bool, string, array } from "prop-types";
import format from "date-fns/format";
import { PortraitModalComponent } from "styled_components/Common/PortraitModalComponent";
import { ModalFooter } from "styled_components/Common/ModalFooter";
import { ModalHeader } from "styled_components/Common/ModalHeader";
import { RESOLUTIONS } from "services/config";
import { BloxButton } from "styled_components/Common/BloxButton";
import { useActiveScreen } from "hooks/useActiveScreen";
import { ServiceRequestContext } from "context/ServiceRequestContext";
import { ErrorMessage } from "utils/CommonConstants";
import { TicketApi } from "services/ticket";
import { MicrosoftApi } from "services/microsoft";
import { formatSupportTicket } from "utils/SupportUtils";
import { Utils } from "services/utils";
import { ConfirmationScreen } from "styled_components/Common/ConfirmationScreen";
import { Permissions } from "services/permissions";
import { DescriptionScreen } from "./Screens/DescriptionScreen";
import { LocationScreen } from "./Screens/LocationScreen";
import { RackDetailsScreen } from "./Screens/RackDetailsScreen";
import { ContactDetailScreen } from "./Screens/ContactDetailScreen";
import { DateTimeSelectionScreen } from "./Screens/DateTimeSelectionScreen";
import { RulesScreen } from "./Screens/RulesScreen";
import { ReviewScreen } from "./Screens/ReviewScreen";
import { SelectionScreen } from "./Screens/SelectionScreen";

import BadgeSVG from "./Screens/badge-icon.svg";

const SCREENS = {
  0: SelectionScreen,
  1: DescriptionScreen,
  2: LocationScreen,
  3: RackDetailsScreen,
  4: ContactDetailScreen,
  5: DateTimeSelectionScreen,
  6: RulesScreen,
  7: ReviewScreen,
  8: ConfirmationScreen,
};
const SUBTITLE = {
  0: "REQUEST TYPE",
  1: "DESCRIPTION",
  2: "SELECT YOUR LOCATION",
  3: "DETAILS",
  4: "CONTACT DETAILS",
  5: "Select an available day and time.",
  6: "DATA CENTER RULES",
  7: "REVIEW",
  8: "CONFIRMED",
};

const SUBTITLE_ILA = {
  0: "REQUEST TYPE",
  1: "DESCRIPTION",
  2: "SELECT YOUR LOCATION",
  3: "PRIORITY",
  4: "CONTACT DETAILS",
  5: "Select an available day and time.",
  6: "DATA CENTER RULES",
  7: "REVIEW",
  8: "CONFIRMED",
};

const TITLE = {
  0: "Select the type of request you require.",
  1: "Please enter the details of your request.",
  2: "Please select the Data center they will need access to.",
  3: "Please enter the pod and cabinet numbers your guest will require access to.",
  4: "Please enter the details of your guest.",
  5: "Please select an available time and date for your guest. You may select up to 3 days consecutively.",
  6: "Your guest will need to read and accept our datacenter rules and regulations prior to be admitted.",
  7: "Please review all details and submit your request.",
  8: "Your request has been submitted. Click the ticket number below to see your ticket.",
};
const TITLE_ILA = {
  0: "Select the type of request you require.",
  1: "Please enter the details of your request.",
  2: "Please select the ILA site they will need access to.",
  3: "Please enter the priority of your request.",
  4: "Please enter the details of your guests.",
  5: "Please select an available time and date for your guest. You may select up to 3 days consecutively.",
  6: "Your guest will need to read and accept our site rules and regulations prior to be admitted.",
  7: "Please review all details and submit your request.",
  8: "Your request has been submitted. Click the ticket number below to see your ticket.",
};

function getSize(breakpoint) {
  let size = "medium";
  if (breakpoint === RESOLUTIONS.MED) {
    size = "medium";
  } else if (breakpoint === RESOLUTIONS.HIGH) {
    size = "medium";
  }

  return size;
}
function getHeader(index, inputs) {
  return (
    <ModalHeader
      image={BadgeSVG}
      text={inputs?.type === "ila" ? TITLE_ILA[index] : TITLE[index]}
      className="guest"
    />
  );
}

function checkSubmitted(inputs) {
  let valid = false;
  if (inputs.submitted) {
    valid = false;
  } else {
    valid = true;
  }
  return valid;
}
function checkEmail(inputs) {
  let valid = false;
  const emailRegex = /^[^@]+@[^@]+.[^@]+$/;
  const email = inputs?.email;
  const phone = inputs?.phone;

  if (inputs.name !== "" && email.match(emailRegex) && phone.length === 14) {
    valid = true;
  }
  return valid;
}

function checkDescription(inputs) {
  const description = inputs.description;
  let valid = false;

  if (
    inputs?.type !== "ila" &&
    description.length >= 10 &&
    inputs.title !== ""
  ) {
    valid = true;
  } else if (
    inputs?.type === "ila" &&
    description.length >= 10 &&
    inputs.title !== "" &&
    inputs?.clearance
  ) {
    valid = true;
  }
  return valid;
}
function checkValidation(activePage, inputs) {
  let valid = false;

  switch (activePage) {
    case 0:
      valid = inputs?.type !== "";
      break;
    case 1:
      valid = checkDescription(inputs);
      break;
    case 2:
      if (inputs?.location !== "") {
        valid = true;
      }
      break;
    case 3:
      if (
        (inputs.podNumber !== "" && inputs.cabNumber !== "") ||
        inputs?.priority !== ""
      ) {
        valid = true;
      }
      break;
    case 4:
      valid = checkEmail(inputs);
      break;
    case 5:
      if (inputs.startDateTime !== "" && inputs.timeSelected) {
        valid = true;
      }
      break;
    case 6:
      if (inputs.rulesAcknowledged) {
        valid = true;
      }
      break;
    case 7:
      valid = checkSubmitted(inputs);
      break;
    case 8:
      valid = true;

      break;
    default:
  }
  return valid;
}
function getButtonText(inputs, activePage) {
  let text = "NEXT";

  switch (activePage) {
    case 0:
      if (inputs.rulesAcknowledged) {
        text = "REVIEW";
      }
      break;
    case 1:
      if (inputs.rulesAcknowledged) {
        text = "REVIEW";
      }
      break;
    case 2:
      if (inputs.rulesAcknowledged) {
        text = "REVIEW";
      }
      break;
    case 3:
      if (inputs.rulesAcknowledged) {
        text = "REVIEW";
      }
      break;
    case 4:
      if (inputs.rulesAcknowledged) {
        text = "REVIEW";
      }
      break;
    case 5:
      if (inputs.rulesAcknowledged) {
        text = "REVIEW";
      }
      break;
    case 6:
      if (inputs.rulesAcknowledged) {
        text = "REVIEW";
      }
      break;
    case 7:
      text = "SUBMIT";
      break;
    default:
  }
  return text;
}
function getButtonFunction(
  buttonText,
  activePage,
  setActivePageIndex,
  auth_status,
  site,
  setModalContent,
  company_info,
  inputs,
  setCaseId,
  change,
  ticketType,
  closeModal
) {
  if (
    activePage === 0 ||
    activePage === 1 ||
    activePage === 2 ||
    activePage === 3 ||
    activePage === 4 ||
    activePage === 5 ||
    activePage === 6
  ) {
    if (buttonText === "REVIEW") {
      return () => setActivePageIndex(7);
    } else {
      return () => setActivePageIndex(activePage + 1);
    }
  } else if (activePage === 7) {
    return () => {
      change({ target: { name: "submitted", value: true } });
      submitTicket(
        setActivePageIndex,
        auth_status,
        site,
        setModalContent,
        inputs,
        setCaseId,
        company_info,
        event,
        change,
        ticketType,
        closeModal
      );
    };
  }
}

function submitCreateEventRequest(
  setActivePageIndex,
  auth_status,
  setModalContent,
  company_info,
  inputs,
  setCaseId,
  change,
  caseId
) {
  const usersEmail = auth_status?.user?.userProfile?.emailAddress;
  const userId = auth_status?.user?.id;
  const datetimestart = inputs?.startDateTime;
  const companyId = company_info?.customer?.id;
  const companyName = company_info?.customer?.companyName;
  const datetimeend = inputs?.endDateTime;
  const attendees = [
    { email: usersEmail, type: "REQUIRED" },
    { email: inputs?.email, type: "REQUIRED" },
  ];
  const eventTitle = `Guest Access - ${company_info?.customer?.companyName}`;
  const startdate = new Date(datetimestart);
  const endDate = new Date(datetimeend);
  const { user } = auth_status;
  const contactDetails = user?.userProfile;
  const ila = inputs?.type === "ila" ? true : false;
  let description = "";
  description += `Customer: ${companyName}\n `;
  description += `Location: ${inputs?.location}\n`;
  description += `Pod Number: ${inputs?.podNumber}\n`;
  description += `Cabinet ID: ${inputs?.cabNumber}\n`;
  if (ila) {
    description += `Requestor: ${user?.firstname}\n`;
    description += `Requestor Email: ${contactDetails?.emailAddress}\n`;
    description += `Requestor Phone number: ${
      contactDetails?.mobile_number
        ? contactDetails?.mobile_number
        : contactDetails?.phone_number
    }\n`;
  } else {
    description += `Guest: ${inputs?.name}\n`;
    description += `Guest Email: ${inputs?.email}\n`;
    description += `Guest Phone number: ${inputs?.phone}\n`;
  }
  description += `Notes: ${inputs?.description}\n`;
  description += `Time: ${format(new Date(), "HH:mm")}`;
  const createEventParams = {
    dataCenter: inputs?.location,
    attendees,
    startDate: {
      year: startdate.getFullYear(),
      month: startdate.getMonth() + 1,
      day: startdate.getDate(),
      hour: startdate.getHours(),
      minute: startdate.getMinutes(),
    },
    endDate: {
      year: endDate.getFullYear(),
      month: endDate.getMonth() + 1,
      day: endDate.getDate(),
      hour: endDate.getHours(),
      minute: endDate.getMinutes(),
    },
    reminder: { on: true, minutes: 1440 },
    recurrence: { type: "None" },
    eventDescription: description,
    eventSubject: eventTitle,
    id: caseId,
    userId,
    orgId: companyId,
  };

  const button = (
    <BloxButton
      className="buttons41"
      id="okay"
      text="OKAY"
      module="support"
      enabled={true}
      onClick={() => {}}
      cypressId="okay"
    />
  );
  MicrosoftApi.createEventRequest(createEventParams)
    .then((response) => {
      const validResponse =
        response.status === 200 && response.data?.eventCreated;
      if (validResponse) {
        setCaseId(caseId);
        setActivePageIndex(8);
      } else {
        change({ target: { name: "submitted", value: false } });
        setModalContent("TIMEOUT_CLOSE", ErrorMessage, button);
      }
    })
    .catch((e) => {
      console.log(e);
      change({ target: { name: "submitted", value: false } });
      setModalContent("TIMEOUT_CLOSE", ErrorMessage, button);
    });
}
function formDescription(inputs, auth_status) {
  const momentStartDatetime = new Date(inputs?.startDateTime);
  const momentEndDatetime = new Date(inputs?.endDateTime);
  const startdate = format(momentStartDatetime, "MMM d, yyyy hh:mm a");
  const enddate = format(momentEndDatetime, "MMM d, yyyy hh:mm a");
  let timezone = "";
  const location = inputs?.location;
  const ila = inputs?.type === "ila" ? true : false;
  const { user } = auth_status;
  const contactDetails = user?.contactDetails;

  if (
    location === "CHA" ||
    location === "ATL" ||
    location === "GSP" ||
    location === "MYR"
  ) {
    timezone = "Eastern Standard Time";
  } else if (location === "HSV" || location === "BHM") {
    timezone = "Central Standard Time";
  } else {
    timezone = "Eastern Standard Time";
  }

  let desc = "";
  desc += `Description: ${inputs?.description}\n`;
  desc += `Location: ${inputs?.location}\n`;
  desc += `Time Zone: ${timezone}\n`;
  desc += `Start Date/Time: ${startdate}\n`;
  desc += `End Date/Time: ${enddate}\n`;
  desc += `Guest: ${inputs?.name}\n`;
  desc += `Guest Email: ${inputs?.email}\n`;
  desc += `Guest Phone number: ${inputs?.phone}\n`;
  desc += `Requestor: ${user?.firstname}\n`;
  desc += `Requestor Email: ${contactDetails?.email}\n`;
  desc += `Requestor Phone number: ${
    contactDetails?.mobile_number
      ? contactDetails?.mobile_number
      : contactDetails?.phone_number
  }\n`;

  // Add shared user information if available
  const sharedUserData = sessionStorage.getItem("sharedUser");
  if (sharedUserData) {
    const { name, email } = JSON.parse(sharedUserData);
    desc += `Shared User Name: ${name}\n`;
    desc += `Shared User Email: ${email}\n`;
  }

  if (!ila) {
    desc += `Cabinet ID: ${inputs?.cabNumber}\n`;
  }

  return desc === "" ? "No Information Included" : desc;
}

async function submitTicket(
  setActivePageIndex,
  auth_status,
  site,
  setModalContent,
  inputs,
  setCaseId,
  company_info,
  event,
  change,
  ticketType,
  closeModal
) {
  const browser_info = await Utils.getClientParams(site);

  const ticket = formatSupportTicket(
    inputs,
    "Guest Access",
    auth_status,
    formDescription,
    company_info,
    browser_info,
    event
  );

  try {
    let response = null;
    let caseId = "";

    if (ticketType?.bonita) {
      response = await TicketApi.createTicket(ticket);
      caseId = response.data?.caseId;
    }

    if (response?.status === 200 && !response.data.error) {
      submitCreateEventRequest(
        setActivePageIndex,
        auth_status,
        setModalContent,
        company_info,
        inputs,
        setCaseId,
        change,
        caseId
      );
      sessionStorage.removeItem("tickets");
    }
    closeModal();
  } catch (e) {
    console.log(e);
  }
}

function getButtonFunction2(activePage, setActivePageIndex, buttonText, pages) {
  const hutPermission = Permissions.checkComponentAccess(
    pages,
    "Overview",
    "add-support-ila"
  );
  const isILA = activePage === 1 && !hutPermission ? false : true;
  if (
    setActivePageIndex &&
    activePage !== 0 &&
    activePage !== 8 &&
    buttonText !== "SUBMIT" &&
    buttonText !== "REVIEW" &&
    isILA
  ) {
    return () => setActivePageIndex(activePage - 1);
  } else {
    return null;
  }
}

export const ServiceRequestGA = ({
  closeModal,
  breakpoint,
  showModal,
  auth_status,
  site,
  setModalContent,
  company_info,
  tickets,
  navigate,
  location,
  services,
  ticketType,
  updateTickets,
  pages,
  setShowInfoModal,
}) => {
  const { activePageIndex, setActivePageIndex } = useActiveScreen(0);
  const [caseId, setCaseId] = useState(null);
  const { inputs, change } = useContext(ServiceRequestContext);
  const Screen = SCREENS[activePageIndex];
  const tour = location?.state?.tour;
  const isEnabled = tour ? true : false;

  const buttonText = getButtonText(inputs, activePageIndex);

  function resetModal() {
    closeModal();
    setActivePageIndex(0);
  }

  useEffect(() => {
    const hutPermission = Permissions.checkComponentAccess(
      pages,
      "Overview",
      "add-support-ila"
    );
    if (!hutPermission) {
      change({ target: { name: "type", value: "datacenter" } });
      setActivePageIndex(1);
    }
  }, []);
  return (
    <div
      className="add-user-request-component-wrapper"
      id="issue-request-component-wrapper"
    >
      <PortraitModalComponent
        closeModal={resetModal}
        show={showModal}
        header={getHeader(activePageIndex, inputs)}
        title="GUEST ACCESS REQUEST"
        subTitle={
          inputs?.type === "ila"
            ? SUBTITLE_ILA[activePageIndex]
            : SUBTITLE[activePageIndex]
        }
        size={getSize(breakpoint)}
        breakpoint={breakpoint}
        customClassName={"guest"}
      >
        <Screen
          setActivePageIndex={setActivePageIndex}
          caseId={caseId}
          tickets={tickets}
          navigate={navigate}
          resetModal={resetModal}
          breakpoint={breakpoint}
          services={services}
          updateTickets={updateTickets}
          setShowInfoModal={setShowInfoModal}
        />
        <ModalFooter
          cypressId="footer"
          id="footer"
          buttonText1={buttonText}
          buttonText2="Back"
          buttonActive1={
            isEnabled ? isEnabled : checkValidation(activePageIndex, inputs)
          }
          buttonActive2={!inputs.submitted}
          module="support"
          buttonFunction1={getButtonFunction(
            buttonText,
            activePageIndex,
            setActivePageIndex,
            auth_status,
            site,
            setModalContent,
            company_info,
            inputs,
            setCaseId,
            change,
            ticketType,
            closeModal
          )}
          size={getSize(breakpoint)}
          buttonFunction2={getButtonFunction2(
            activePageIndex,
            setActivePageIndex,
            buttonText,
            pages
          )}
        />
      </PortraitModalComponent>
    </div>
  );
};

ServiceRequestGA.propTypes = {
  closeModal: func.isRequired,
  breakpoint: string.isRequired,
  showModal: bool.isRequired,
  setModalContent: func.isRequired,
  auth_status: object.isRequired,
  company_info: object.isRequired,
  site: object.isRequired,
  tickets: array.isRequired,
};

ServiceRequestGA.defaultProps = {};
